/* AlignPro Theme JS — vanilla, defensive */
(function () {
  'use strict';

  const routes = (window.theme && window.theme.routes) || {
    cart_add: '/cart/add.js',
    cart_change: '/cart/change.js',
    cart_url: '/cart',
    cart_get: '/cart.js'
  };
  const settings = (window.theme && window.theme.settings) || { freeShippingThreshold: 35, currency: 'USD' };

  /* ---------- Helpers ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.from((c || document).querySelectorAll(s)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---------- Sticky header ---------- */
  function initHeader() {
    const header = $('.header');
    if (!header) return;
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    const toggle = $('[data-mobile-nav-toggle]');
    const nav = $('[data-mobile-nav]');
    if (!toggle || !nav) return;
    const closes = $$('[data-mobile-nav-close]');
    const open = () => { nav.classList.add('is-open'); document.body.classList.add('scroll-lock'); };
    const close = () => { nav.classList.remove('is-open'); document.body.classList.remove('scroll-lock'); };
    on(toggle, 'click', open);
    closes.forEach((c) => on(c, 'click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  /* ---------- Cart Drawer ---------- */
  const cartDrawer = {
    el: null,
    open() { if (!this.el) this.el = $('#CartDrawer'); if (this.el) { this.el.classList.add('is-open'); this.el.setAttribute('aria-hidden', 'false'); document.body.classList.add('scroll-lock'); } },
    close() { if (this.el) { this.el.classList.remove('is-open'); this.el.setAttribute('aria-hidden', 'true'); document.body.classList.remove('scroll-lock'); } },
    render(cart) {
      if (!this.el) this.el = $('#CartDrawer');
      const body = $('[data-cart-body]', this.el);
      const footer = $('[data-cart-footer]', this.el);
      const subtotalEl = $('[data-cart-subtotal]', this.el);
      const shippingTextEl = $('[data-shipping-text]', this.el);
      const shippingProgressEl = $('[data-shipping-progress]', this.el);
      if (!cart || !cart.items || cart.items.length === 0) {
        body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
        if (footer) footer.hidden = true;
        return;
      }
      body.innerHTML = cart.items.map((item) => {
        const img = item.image ? `<img src="${item.image}" alt="${item.product_title}">` : '';
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer__item-meta">${item.variant_title}</div>` : '';
        return `<div class="cart-drawer__item" data-line-key="${item.key}">
          <div class="cart-drawer__item-img">${img}</div>
          <div>
            <div class="cart-drawer__item-title">${item.product_title}</div>
            ${variant}
            <div class="cart-drawer__item-meta">Qty: ${item.quantity}</div>
            <a href="#" class="cart-drawer__item-remove" data-line-remove="${item.key}">Remove</a>
          </div>
          <div class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</div>
        </div>`;
      }).join('');
      if (footer) footer.hidden = false;
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
      const threshold = settings.freeShippingThreshold * 100;
      const subtotal = cart.items_subtotal_price;
      const pct = Math.min(100, (subtotal / threshold) * 100);
      if (shippingProgressEl) shippingProgressEl.style.width = pct + '%';
      if (shippingTextEl) {
        if (subtotal >= threshold) {
          shippingTextEl.textContent = 'You qualify for FREE shipping!';
        } else {
          const remaining = (threshold - subtotal) / 100;
          shippingTextEl.textContent = `Add $${remaining.toFixed(2)} more for FREE shipping`;
        }
      }
      $$('[data-line-remove]', body).forEach((a) => {
        on(a, 'click', (e) => {
          e.preventDefault();
          const key = a.getAttribute('data-line-remove');
          changeLine(key, 0);
        });
      });
    }
  };

  function fetchCart() {
    return fetch(routes.cart_get).then((r) => r.json());
  }

  function refreshCartCount(cart) {
    const el = $('[data-cart-count]');
    if (!el) return;
    el.textContent = cart.item_count || 0;
    el.style.display = cart.item_count > 0 ? '' : 'none';
  }

  function addToCart(formData) {
    return fetch(routes.cart_add, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then((r) => r.json());
  }

  function changeLine(key, qty) {
    return fetch(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then((r) => r.json()).then((cart) => {
      cartDrawer.render(cart);
      refreshCartCount(cart);
      return cart;
    });
  }

  function initAddToCart() {
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.origText = submitBtn.textContent; submitBtn.textContent = 'Adding...'; }
      addToCart(new FormData(form)).then(() => {
        return fetchCart();
      }).then((cart) => {
        cartDrawer.render(cart);
        refreshCartCount(cart);
        cartDrawer.open();
      }).catch(() => {
        alert('Sorry, we could not add that item to your cart.');
      }).finally(() => {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.origText || 'Add to cart'; }
      });
    });
  }

  function initCartTriggers() {
    $$('[data-cart-open]').forEach((b) => on(b, 'click', (e) => { e.preventDefault(); fetchCart().then((c) => cartDrawer.render(c)); cartDrawer.open(); }));
    $$('[data-cart-close]').forEach((b) => on(b, 'click', (e) => { e.preventDefault(); cartDrawer.close(); }));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') cartDrawer.close(); });
  }

  /* ---------- Quantity ---------- */
  function initQty() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      const wrap = btn.closest('[data-qty]');
      const input = wrap && wrap.querySelector('input[type="number"]');
      if (!input) return;
      const dir = parseInt(btn.getAttribute('data-qty-change'), 10);
      const val = Math.max(1, (parseInt(input.value, 10) || 1) + dir);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.addEventListener('change', (e) => {
      const input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      const key = input.getAttribute('data-cart-qty');
      const qty = parseInt(input.value, 10) || 0;
      changeLine(key, qty).then(() => { window.location.reload(); });
    });

    document.addEventListener('click', (e) => {
      const rm = e.target.closest('[data-cart-remove]');
      if (!rm) return;
      e.preventDefault();
      const key = rm.getAttribute('data-cart-remove');
      changeLine(key, 0).then(() => { window.location.reload(); });
    });
  }

  /* ---------- Product Variant Picker ---------- */
  function initVariantPickers() {
    $$('[data-variant-picker]').forEach((picker) => {
      const productData = JSON.parse(picker.getAttribute('data-product-json') || '{}');
      const variants = productData.variants || [];
      const update = () => {
        const selected = $$('[data-option-input]:checked', picker).map((i) => i.value);
        const variant = variants.find((v) => JSON.stringify(v.options) === JSON.stringify(selected));
        if (!variant) return;
        const idInput = $('[data-variant-id]');
        const priceEl = $('[data-product-price]');
        const submitBtn = $('[data-product-submit]');
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.innerHTML = formatMoney(variant.price);
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }
        if (variant.featured_image) {
          const main = $('[data-product-main-image]');
          if (main) main.src = variant.featured_image.src || variant.featured_image;
        }
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        } catch (e) {}
      };
      $$('[data-option-input]', picker).forEach((input) => on(input, 'change', update));
      $$('[data-option-pill]', picker).forEach((pill) => on(pill, 'click', (e) => {
        e.preventDefault();
        const input = $('#' + pill.getAttribute('data-for'));
        if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        const group = pill.closest('.product__option-values');
        if (group) $$('.product__option-value', group).forEach((p) => p.classList.remove('is-active'));
        pill.classList.add('is-active');
      }));
    });
  }

  /* ---------- Product Gallery ---------- */
  function initGallery() {
    const thumbs = $$('[data-thumb]');
    const main = $('[data-product-main-image]');
    if (!main || !thumbs.length) return;
    thumbs.forEach((t) => on(t, 'click', (e) => {
      e.preventDefault();
      const src = t.getAttribute('data-thumb');
      if (src) main.src = src;
      thumbs.forEach((x) => x.classList.remove('is-active'));
      t.classList.add('is-active');
    }));
  }

  /* ---------- Accordion ---------- */
  function initAccordion() {
    $$('[data-accordion] .accordion__trigger').forEach((btn) => {
      on(btn, 'click', () => {
        const item = btn.closest('.accordion__item');
        if (item) item.classList.toggle('is-open');
      });
    });
  }

  /* ---------- Newsletter validation ---------- */
  function initNewsletter() {
    $$('form[data-newsletter]').forEach((form) => {
      on(form, 'submit', (e) => {
        const email = form.querySelector('input[type="email"]');
        if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value)) {
          e.preventDefault();
          const errorEl = form.querySelector('.newsletter__error') || document.createElement('p');
          errorEl.className = 'newsletter__error';
          errorEl.textContent = 'Please enter a valid email.';
          if (!errorEl.parentNode) form.appendChild(errorEl);
        }
      });
    });
  }

  /* ---------- Reveals ---------- */
  function initReveals() {
    if (!('IntersectionObserver' in window)) {
      $$('.reveal').forEach((el) => el.classList.add('is-revealed'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('.reveal').forEach((el) => io.observe(el));
  }

  /* ---------- Boot ---------- */
  function boot() {
    initHeader();
    initMobileNav();
    initCartTriggers();
    initAddToCart();
    initQty();
    initVariantPickers();
    initGallery();
    initAccordion();
    initNewsletter();
    initReveals();
    // Initial cart count
    fetchCart().then((c) => refreshCartCount(c)).catch(() => {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
